import { render, staticRenderFns } from "./FollowUpBusiness.vue?vue&type=template&id=0d709ad3&scoped=true"
import script from "./FollowUpBusiness.vue?vue&type=script&lang=js"
export * from "./FollowUpBusiness.vue?vue&type=script&lang=js"
import style0 from "./FollowUpBusiness.vue?vue&type=style&index=0&id=0d709ad3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d709ad3",
  null
  
)

export default component.exports